import { t } from 'i18next';
import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { live } from 'lit/directives/live.js';

import { iconMinusCircle, iconPlusCircle } from '@/components/icons';
import { baseStyles, formStyles } from '@/styles';
import { QuantityInputMixin } from './quantity-input-mixin';

@customElement('fg-quantity-table-quantity-input')
export class FgQuantityTableQuantityInput extends QuantityInputMixin(
  LitElement,
) {
  @property({ type: Boolean })
  showQuantityIncrementButtons = true;

  @property({ type: Boolean })
  multiSelect = false;

  @property({ type: String })
  name = '';

  @property({ type: String })
  title = '';

  render() {
    const value = this.data.quantity > 0 ? this.data.quantity.toString() : '';
    const initialValue = this.quantity > 0 ? this.quantity.toString() : '';

    return html`
      <div class=${this.multiSelect ? 'multi-select' : ''}>
        ${this.showQuantityIncrementButtons
          ? html`
              <button
                aria-label=${t('actions.decreaseByOne') || ''}
                ?disabled=${this.data.quantity === 0 || this.disabled}
                @click=${() => this.setQuantity(this.data.quantity - 1)}
              >
                ${iconMinusCircle}
              </button>
            `
          : nothing}

        <input
          placeholder="0"
          .value=${live(this.firstInteracted ? value : initialValue)}
          ?disabled=${this.disabled}
          @input=${(e: KeyboardEvent) => this.onChangeQuantity(e)}
          .name=${this.name}
          .title=${this.title}
        />

        ${this.showQuantityIncrementButtons
          ? html`
              <button
                aria-label=${t('actions.increaseByOne') || ''}
                ?disabled=${this.disabled}
                @click=${() => this.setQuantity(this.data.quantity + 1)}
              >
                ${iconPlusCircle}
              </button>
            `
          : nothing}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    formStyles,
    css`
      div {
        display: inline-flex;
        gap: 5px;
        align-items: center;
      }

      input {
        width: 50px;
      }

      :host([part='wholesale']) input {
        width: 126px;
      }

      .multi-select input {
        width: 60px;
      }

      button {
        color: var(--fg-primary, var(--fg-fallback-primary));
        width: 18px;
        height: 18px;
      }

      button:disabled {
        color: var(--fg-gray--500, var(--fg-fallback-gray--500));
        pointer-events: none;
      }
    `,
  ];
}
